import { MODULE_NAME } from "../moduleName";

export const LOADED_ORGANISATION_LIST = `${MODULE_NAME}/LOADED_ORGANISATION_LIST`;
export const LOADING_ORGANISATION_LIST = `${MODULE_NAME}/LOADING_ORGANISATION_LIST`;

export const LOADED_ORGANISATION = `${MODULE_NAME}/LOADED_ORGANISATION`;
export const LOADING_ORGANISATION = `${MODULE_NAME}/LOADING_ORGANISATION`;

export const EDIT_ORGANISATION = `${MODULE_NAME}/EDIT_ORGANISATION`;
export const EDIT_ORGANISATION_SUCCESS = `${MODULE_NAME}/EDIT_ORGANISATION_SUCCESS`;
export const EDIT_ORGANISATION_ERROR = `${MODULE_NAME}/EDIT_ORGANISATION_ERROR`;

export const EDIT_ORGANISATION_ENGAGEMENT = `${MODULE_NAME}/EDIT_ORGANISATION_ENGAGEMENT`;
export const EDIT_ORGANISATION_ENGAGEMENT_SUCCESS = `${MODULE_NAME}/EDIT_ORGANISATION_ENGAGEMENT_SUCCESS`;
export const EDIT_ORGANISATION_ENGAGEMENT_ERROR = `${MODULE_NAME}/EDIT_ORGANISATION_ENGAGEMENT_ERROR`;

export const ADD_ORGANISATION_ENGAGEMENT_EVENT = `${MODULE_NAME}/ADD_ORGANISATION_ENGAGEMENT_EVENT`;
export const EDIT_ORGANISATION_ENGAGEMENT_EVENT = `${MODULE_NAME}/EDIT_ORGANISATION_ENGAGEMENT_EVENT`;

export const APPROVING_CHANGE = `${MODULE_NAME}/APPROVING_CHANGE`;
export const APPROVED_CHANGE = `${MODULE_NAME}/APPROVED_CHANGE`;

export const CLOSE_APPLICATION = `${MODULE_NAME}/CLOSE_APPLICATION`;
export const REOPEN_APPLICATION = `${MODULE_NAME}/REOPEN_APPLICATION`;

export const RELEASE_APPLICATION = `${MODULE_NAME}/RELEASE_APPLICATION`;

export const SENDING_MESSAGE = `${MODULE_NAME}/SENDING_MESSAGE`;
export const SENDING_ATTACHMENTS = `${MODULE_NAME}/SENDING_ATTACHMENTS`;

export const LOADED_APPLICATION = `${MODULE_NAME}/LOADED_APPLICATION`;
export const LOADING_APPLICATION = `${MODULE_NAME}/LOADING_APPLICATION`;

export const EDIT_APPLICATION = `${MODULE_NAME}/EDIT_APPLICATION`;
export const EDIT_APPLICATION_SUCCESS = `${MODULE_NAME}/EDIT_APPLICATION_SUCCESS`;
export const EDIT_APPLICATION_ERROR = `${MODULE_NAME}/EDIT_APPLICATION_ERROR`;

export const APPROVE_APPLICATION = `${MODULE_NAME}/APPROVE_APPLICATION`;
export const REJECT_APPLICATION = `${MODULE_NAME}/REJECT_APPLICATION`;
export const WITHDRAW_APPLICATION = `${MODULE_NAME}/WITHDRAW_APPLICATION`;

export const LOADING_EXPANSION_APPLICATION_LIST = `${MODULE_NAME}/LOADING_EXPANSION_APPLICATION_LIST`;
export const LOADED_EXPANSION_APPLICATION_LIST = `${MODULE_NAME}/LOADED_EXPANSION_APPLICATION_LIST`;

export const LOADED_ORGANISATION_SCOPES = `${MODULE_NAME}/LOADED_ORGANISATION_SCOPES`;
export const LOADING_ORGANISATION_SCOPES = `${MODULE_NAME}/LOADING_ORGANISATION_SCOPES`;

export const LOADED_APPLICATION_SCOPES = `${MODULE_NAME}/LOADED_APPLICATION_SCOPES`;
export const LOADING_APPLICATION_SCOPES = `${MODULE_NAME}/LOADING_APPLICATION_SCOPES`;

export const ADD_SCOPE = `${MODULE_NAME}/ADD_SCOPE`;
export const TOGGLE_DELETE_SCOPE = `${MODULE_NAME}/TOGGLE_DELETE_SCOPE`;
export const DELETE_SCOPES = `${MODULE_NAME}/DELETE_SCOPES`;
export const UPDATE_SCOPE = `${MODULE_NAME}/UPDATE_SCOPE`;
export const UPDATING_SCOPES = `${MODULE_NAME}/UPDATING_SCOPES`;
export const CREATE_SCOPES = `${MODULE_NAME}/CREATE_SCOPES`;
export const UPDATE_ORGS_PARAMS = `${MODULE_NAME}/UPDATE_ORGS_PARAMS`;

export const ASSIGN_ORGANISATION = `${MODULE_NAME}/ASSIGN_ORGANISATION`;
export const UNASSIGNING_ORGANISATION = `${MODULE_NAME}/UNASSIGNING_ORGANISATION`;

export const UPDATING_SHARE = `${MODULE_NAME}/UPDATING_SHARE`;
export const LOADED_SHARE = `${MODULE_NAME}/LOADED_SHARE`;

